import React from 'react'
import classnames from 'classnames'

const InventoryCenterSVG = ({ className }) => {
  return (
    <svg
      viewBox="0 0 39 32"
      className={classnames('dealmed-icon', className)}
      aria-hidden={true}
      focusable={false}
    >
      <path d="M32.492 22.154h-10.831v-6.892c0-0.542-0.443-0.985-0.985-0.985h-13.785c-0.542 0-0.985 0.443-0.985 0.985v15.754c0 0.542 0.443 0.985 0.985 0.985h25.6c0.542 0 0.985-0.443 0.985-0.985v-7.877c0-0.542-0.443-0.985-0.985-0.985zM19.692 30.031h-11.815v-5.908h11.815v5.908zM19.692 22.154h-11.815v-5.908h11.815v5.908zM31.508 30.031h-9.846v-5.908h9.846v5.908zM37.575 7.772l-16.738-7.052c-0.726-0.308-1.557-0.308-2.289 0l-16.738 7.052c-1.102 0.462-1.809 1.532-1.809 2.72v21.015c0 0.271 0.222 0.492 0.492 0.492h0.985c0.271 0 0.492-0.221 0.492-0.492v-21.015c0-0.4 0.234-0.751 0.603-0.911l16.738-7.052c0.24-0.105 0.523-0.105 0.763 0l16.738 7.052c0.369 0.154 0.603 0.511 0.603 0.911v21.015c0 0.271 0.221 0.492 0.492 0.492h0.985c0.271 0 0.492-0.221 0.492-0.492v-21.015c0-1.188-0.708-2.258-1.809-2.72z"></path>
    </svg>
  )
}

export default InventoryCenterSVG
